export * from './serializable.interface'

export interface EssentialObject {
  id: number
  name: string
}
